module.exports = __webpack_public_path__ + "img/difficultyLevel_2.ef653c39.svg";